import { ReactNode } from 'react';
import { getImageUrls } from '@oneaudi/feature-app-utils';
import {
  ParallaxTeaserProps,
  WltpProps,
  ImagesProps as ContentImagesProps,
} from '../components/ParallaxTeaser/ComponentTypes';
import { Content, ImagesProps } from '../EditorContentTypes';

const mapImages = (image: ImagesProps): ContentImagesProps => {
  return {
    imageXS: getImageUrls(image.imageXS.assetValue)[0],
    imageS: getImageUrls(image.imageS.assetValue)[0],
    imageM: getImageUrls(image.imageM.assetValue)[0],
    imageXL: getImageUrls(image.imageXL.assetValue)[0],
    altText: image.altText,
  };
};

export type HeadlineTag = 'h2' | 'h3' | 'h4';

export interface MappingProps {
  content: Content;
  headline: string | ReactNode[];
  headlineTag?: HeadlineTag;
  copy: string | ReactNode[];
  additionalLegalText?: string | ReactNode[];
  wltpData: WltpProps[];
}

export const mapToTeaserProps = ({
  content,
  headline,
  headlineTag,
  copy,
  additionalLegalText: additionalText,
  wltpData,
}: MappingProps): ParallaxTeaserProps => ({
  headline,
  headlineTag,
  copy,
  links: content.links,
  linkType: content.linkType,
  images: mapImages(content.images),
  legalData: {
    theme: content.legalData.theme,
    additionalText,
    wltpData,
  },
});
